"use client";
import { createStore } from "zustand";
import { createContext, useRef } from "react";
import type { StoreApi } from "zustand";
import { usePost } from "@hooks/useRequest";

interface IStore {
  nickname: string;
  permissionList: string[];
  gender: string;
  email: string;
  avatar: string;
  phone: string;
  roleList: string[];
  username: string;
  permissionTree: any[];
  refetchPermissionTree: () => void;
  refetchPermissionList: () => void;
  refetchDics: () => void;
  dics: any[];
  isFullScreen: boolean;
  setIsFullScreen: (isFullScreen: boolean) => void;
}

type ExtendedStoreApi = StoreApi<IStore> & {
  destroy: () => void;
  permissionTree: any[];
  permissionList: string[];
  dics: any[];
};

export const StoreContext = createContext<ExtendedStoreApi | null>(null);

// StoreProvider 组件
export const StoreProvider = ({
  children,
  data,
}: {
  children: React.ReactNode;
  data: Partial<IStore>;
}) => {
  const storeRef = useRef<StoreApi<IStore> | null>(null);

  const { data: res = [], refetch: refetchPermissionTree } = usePost(
    "/manage/system/resource/v1/querySystemPermissionTree",
    undefined,
    {
      initialData: data.permissionTree || [],
    }
  );
  const { data: res2 = [], refetch: refetchPermissionList } = usePost(
    "/manage/common/resource/v1/querySystemPermissionCodeListByUserId",
    undefined,
    {
      initialData: data.permissionList || [],
    }
  );

    const { data: res3 = [], refetch: refetchDics } = usePost(
    "/manage/common/resource/v1/queryGeneralEnumList",
    undefined,
    {
      initialData: data.permissionList || [],
    }
  );

  if (storeRef.current == null) {
    // 创建 store（仅一次）
    storeRef.current = createStore<IStore>((set) => ({
      nickname: "",
      permissionList: [],
      gender: "",
      email: "",
      avatar: "",
      phone: "",
      roleList: [],
      username: "",
      permissionTree: [],
      dics: [],
      ...data,
      refetchPermissionTree,
      refetchPermissionList,
      refetchDics,
      isFullScreen: false,
      setIsFullScreen: (isFullScreen: boolean) => set({ isFullScreen }),
    }));
  }

  return (
    <StoreContext.Provider
      value={{
        ...storeRef.current,
        getState: () => ({
          ...storeRef.current!.getState(),
          permissionTree: res || [],
          permissionList: res2 || [],
        }),
        setState: storeRef.current!.setState,
        subscribe: storeRef.current!.subscribe,
        destroy: (storeRef.current as any)!.destroy,
        permissionTree: res || [],
        permissionList: res2 || [],
        dics: res3 || [],
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
